let isLittle: boolean

export function isLittleEndian() {
	if (isLittle != null) {
		return isLittle
	}

	const buffer = new ArrayBuffer(2)
	new DataView(buffer).setInt16(0, 256, true /* littleEndian */)
	// Int16Array uses the platform's endianness.
	isLittle = new Int16Array(buffer)[0] === 256

	return isLittle
}
